import { combineReducers } from '@reduxjs/toolkit'
import drawer from './drawerSlice'
import dialog from './dialogSlice'
import footer from './footerSlice'

const reducer = combineReducers({
    drawer,
    footer,
    dialog
})

export default reducer
